export enum MessageType {
  ALERT = 'ALERT',
  TOAST = 'TOAST'
}
